import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Element as ScrollElement, scroller } from 'react-scroll/modules';
import styles from '../styles/pages/Engagement.module.css';
import DefaultPage from './DefaultPage';
import { ActionButton } from '@ax2/common/components/ActionButton';
import { PanelTileInfo, PanelTiles } from '../components/PanelTiles';

const tiles: PanelTileInfo[] = [
  {
    title: <>Health Plan Panel</>,
    imageSrc: require('../assets/engagement/panel3.png'),
    imageAlt: 'Health Plan Panel',
    description: (
      <>
        <p>
          <strong>What you get when you purchase this panel:</strong>
        </p>
        <ul>
          <li>
            <strong>
              20 pharmacy and medical executives from our health plan panel.
            </strong>
          </li>
          <li>
            Panel includes over 4,000 medical and pharmacy decision makers from
            regional, national and blues health plans.
          </li>
          <li>
            Includes executives from all leading health plans, as well as health
            plans covering over 100,000 or more lives.
          </li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Serves as VP of pharmaceutical contracting for a national health
              plan. Responsible for overseeing manufacturer relations and rebate
              programs. Serves as a voting member of the P&T committee member
              for commercial, Medicare, and Medicaid formularies. Develops
              contracting pricing requirements and guidelines. Served in a
              similar position in the past with an IDN- based health plan.
            </li>
            <li>
              Serves as Chief Medical Officer for a national healthcare plan.
              Responsible for Medicare, Medicaid business lines and Commercial
              Plans. Currently developing and implementing behavioral health
              benefits packages and reform incentive payments programs. Has
              extensive medical and pharmacy policy experience as well as
              development and benefits administration, healthcare utilization
              management, and compliance and quality assurance.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example organizations',
        modalTitle: 'Example organizations',
        modalContent: (
          <ul>
            <li>Aetna</li>
            <li>AmeriHealth</li>
            <li>Anthem</li>
            <li>Centene</li>
            <li>Cigna</li>
            <li>HCSC</li>
            <li>Humana</li>
            <li>Kaiser</li>
            <li>UnitedHealth Group</li>
            <li>WellCare</li>
          </ul>
        ),
      },
    ],
  },
  {
    title: (
      <>
        Health Plan & Phar&shy;ma&shy;cy Be&shy;ne&shy;fit Ma&shy;na&shy;ger
        (PBM) Pa&shy;nel (Combo)
      </>
    ),
    imageSrc: require('../assets/engagement/panel1.png'),
    imageAlt: 'Health Plan & Pharmacy Benefit Manager (PBM) Panel (Combo)',
    description: (
      <>
        <p>
          <strong>This allows you to have a combination of two panels:</strong>
        </p>
        <ul>
          <li>
            <strong>
              17-18 pharmacy and medical executives from our health plan panel.
            </strong>
            <ul>
              <li>
                Panel includes executives from all leading health plans. Over
                4,000 medical and pharmacy decision makers from regional,
                national and blues health plans covering over 100,000 lives.
              </li>
            </ul>
          </li>

          <li>
            <strong>
              2-3 pharmacy and medical executives from our PBM panel.
            </strong>
            <ul>
              <li>
                Panel includes over 500 pharmacy, contracting, medical, and
                executive decision makers from the nation’s leading PBMs and
                intermediaries.
              </li>
            </ul>
          </li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Health plan executive: Serves as Chief Medical Officer for a
              national healthcare plan. Responsible for Medicare, Medicaid
              business lines and Commercial Plans. Currently developing and
              implementing behavioral health benefits packages and reform
              incentive payments programs. Has extensive medical and pharmacy
              policy experience as well as development and benefits
              administration, healthcare utilization management, and compliance
              and quality assurance.
            </li>
            <li>
              PBM executive: Has over 20 years of experience in a leadership
              role on Pharmacy Benefit Management and Managed Care
              organizations. Serves as Vice President of Formulary Services.
              Responsible for strategy leadership for Commercial, Exchange, and
              Medicaid formulary. Contributor to several industry publications
              and is involved in educational programs.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example organizations',
        modalTitle: 'Example organizations',
        modalContent: (
          <>
            <p>
              <strong>Health plan:</strong>
            </p>
            <ul>
              <li>Aetna</li>
              <li>AmeriHealth</li>
              <li>Anthem</li>
              <li>Centene</li>
              <li>Cigna</li>
              <li>HCSC</li>
              <li>Humana</li>
              <li>Kaiser</li>
              <li>UnitedHealth Group</li>
              <li>WellCare</li>
            </ul>
            <p>
              <strong>PBM:</strong>
            </p>
            <ul>
              <li>CVS Health</li>
              <li>Diplomat</li>
              <li>Express Scripts</li>
              <li>Magellan</li>
              <li>OptumRx</li>
              <li>Prime Therapeutics</li>
              <li>Rite Aid</li>
              <li>Walgreens</li>
              <li>Walmart</li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: <>Health Plan & Hospital System Panel (Combo)</>,
    imageSrc: require('../assets/engagement/panel5.png'),
    imageAlt: 'Health Plan & Hospital System Panel (Combo)',
    description: (
      <>
        <p>
          <strong>This allows you to have a combination of two panels:</strong>
        </p>
        <ul>
          <li>
            <strong>
              10 pharmacy and medical executives from our health plan panel.
            </strong>
            <ul>
              <li>
                Panel includes executives from all leading health plans. Over
                4,000 medical and pharmacy decision makers from regional,
                national and blues health plans covering over 100,000 lives.
              </li>
            </ul>
          </li>

          <li>
            <strong>
              10 medical executives from our hospital system panel.
            </strong>
            <ul>
              <li>
                Panel includes over 2,900 medical and pharmacy decision-makers
                from top integrated hospital systems. Hospital systems are
                defined as systems that integrate one or more services or
                organizations with their hospital facilities. Our panel
                development is focused on the top 100 integrated delivery
                networks in the US, selected by bed size, number of patients
                seen, number of hospitals, and medical groups owned, some with a
                health plan component.
              </li>
            </ul>
          </li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Health plan executive: Serves as Chief Medical Officer for a
              national healthcare plan. Responsible for Medicare, Medicaid
              business lines and Commercial Plans. Currently developing and
              implementing behavioral health benefits packages and reform
              incentive payments programs. Has extensive medical and pharmacy
              policy experience as well as development and benefits
              administration, healthcare utilization management, and compliance
              and quality assurance.
            </li>
            <li>
              Hospital system executive: Serves as Director of Formulary
              Contracting and Management at one of the nation’s top-ranked
              health systems. Responsible for creating a developing a
              pharmaceutical contracting program for outpatient services and
              later became responsible for the managed care rebate program.
              Responsible for contracting the pharmaceutical distribution,
              products and services that flow through the organization’s
              pharmacies. Member of the board of directors of the AMCP.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example organizations',
        modalTitle: 'Example organizations',
        modalContent: (
          <>
            <p>
              <strong>Health plan:</strong>
            </p>
            <ul>
              <li>Aetna</li>
              <li>AmeriHealth</li>
              <li>Anthem</li>
              <li>Centene</li>
              <li>Cigna</li>
              <li>HCSC</li>
              <li>Humana</li>
              <li>Kaiser</li>
              <li>UnitedHealth Group</li>
              <li>WellCare</li>
            </ul>
            <p>
              <strong>Hospital system:</strong>
            </p>
            <ul>
              <li>Advocate Aurora Health</li>
              <li>Allina Health</li>
              <li>Ascension</li>
              <li>Aspirus</li>
              <li>Atlantic Health System</li>
              <li>Atrium Health</li>
              <li>Baylor Scott & White Health</li>
              <li>BJC HealthCare</li>
              <li>Carilion Clinic</li>
              <li>CHI St. Joseph Health</li>
              <li>Christiana Care Health System</li>
              <li>Cleveland Clinic</li>
              <li>Geisinger</li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: <>Hospital System Panel</>,
    imageSrc: require('../assets/engagement/panel4.png'),
    imageAlt: 'Hospital System Panel',
    description: (
      <>
        <p>
          <strong>What you get when you purchase this panel:</strong>
        </p>
        <ul>
          <li>
            <strong>
              20 pharmacy and medical executives from our hospital system panel.
            </strong>
          </li>
          <li>
            Panel includes over 2,900 medical and pharmacy decision-makers from
            top integrated hospital systems.
          </li>
          <li>
            Hospital systems defined as systems that integrate one or more
            services or organizations with their hospital facilities: ambulatory
            surgery center, oncology center, rehabilitation, specialty pharmacy,
            etc.
          </li>
          <li>
            Panel development is focused on the top 100 integrated delivery
            networks in the US, selected by bed size, number of patients seen,
            number of hospitals, and medical groups owned, some with a health
            plan component.
          </li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Serves as VP for Medical Affairs and Chief Medical Officer at a
              large academic health system. Oversees medical affairs programs
              throughout the full network of hospitals, medical groups, and
              clinics. Responsibilities include ensuring all staff are aligned
              to the health systems quality, clinical programs, and strategy
              plans. Is charged with addressing the changing needs of patients
              in an evolving landscape. Winner of numerous awards pertaining to
              excellence in teaching and leadership.
            </li>
            <li>
              Serves as Director of Formulary Contracting and Management at one
              of the nation’s top-ranked health systems. Responsible for
              creating a developing a pharmaceutical contracting program for
              outpatient services and later became responsible for the managed
              care rebate program. Responsible for contracting the
              pharmaceutical distribution, products and services that flow
              through the organization’s pharmacies. Member of the board of
              directors of the AMCP.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example organizations',
        modalTitle: 'Example organizations',
        modalContent: (
          <li>
            <li>Advocate Aurora Health</li>
            <li>Allina Health</li>
            <li>Ascension</li>
            <li>Aspirus</li>
            <li>Atlantic Health System</li>
            <li>Atrium Health</li>
            <li>Baylor Scott & White Health</li>
            <li>BJC HealthCare</li>
            <li>Carilion Clinic</li>
            <li>CHI St. Joseph Health</li>
            <li>Christiana Care Health System</li>
            <li>Cleveland Clinic</li>
            <li>Geisinger</li>
          </li>
        ),
      },
    ],
  },
  {
    title: <>Oncology Center Panel</>,
    imageSrc: require('../assets/engagement/panel2.png'),
    imageAlt: 'Oncology Center Panel',
    description: (
      <>
        <p>
          <strong>What you get when you purchase this panel:</strong>
        </p>
        <ul>
          <li>
            <strong>
              15 pharmacy and medical executives from our oncology center panel.
            </strong>
          </li>
          <li>
            Panel includes over 1,600 medical and pharmacy executives from top
            oncology centers
          </li>
          <li>
            Includes stand-alone oncology groups, university affiliated cancer
            clinics and hospital system affiliated cancer centers
          </li>
          <li>Focused on the top 200 oncology centers in the United States</li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Associate Chief of the Division of Oncology and serves as a
              director of a Breast Cancer Program at a large regional health
              system with a renowned oncology program. Accomplishments include
              managing over 30 clinical trials. Has won numerous distinguished
              scholar wards, ranked as one of America’s top doctors for cancer
              treatment, and contributes to a number of oncology publications.
            </li>
            <li>
              Serves as Executive Director of leading oncology medical group.
              Responsible for strategic development, operational oversight and
              leadership for the organization’s western region covering over 400
              oncologists.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example organizations',
        modalTitle: 'Example organizations',
        modalContent: (
          <ul>
            <li>MD Anderson Cancer Center</li>
            <li>
              AmeriHeaMemorial Sloan Kettering Cancer Center Mayo Cliniclth
            </li>
            <li>Dana-Farber/Brigham and Women’s Cancer Center</li>
            <li>Cleveland Clinic</li>
            <li>The Johns Hopkins Hospital</li>
            <li>Seattle Cancer Care Alliance at UW Medical Center</li>
            <li>Moffitt Cancer Center</li>
            <li>UCSF Medical Center</li>
            <li>
              Hospitals of the University of Pennsylvania-Penn Presbyterian
            </li>
          </ul>
        ),
      },
    ],
  },
  {
    title: <>Physician Panel</>,
    imageSrc: require('../assets/engagement/physician1.png'),
    imageAlt: 'Physician Panel',
    description: (
      <>
        <p>
          <strong>What you get when you purchase this panel:</strong>
        </p>
        <ul>
          <li>40 practicing physicians from our physician panel</li>
          <li>Panel includes over 600,000 HCPs across 25+ specialties</li>
        </ul>
      </>
    ),
    links: [
      {
        linkTitle: 'View panel expert bios',
        modalTitle: 'Panel expert bios',
        modalContent: (
          <ul>
            <li>
              Practicing U.S. physicians responsible for overseeing patient care
              in various therapeutic areas and practice settings.
            </li>
          </ul>
        ),
      },
      {
        linkTitle: 'View example specialties',
        modalTitle: 'Example specialties',
        modalContent: (
          <ul>
            <li>Allergy</li>
            <li>Cardiology</li>
            <li>Dermatology</li>
            <li>Endocrinology</li>
            <li>Gastroenterology</li>
            <li>Infections Disease</li>
            <li>Internal Medicine</li>
            <li>Oncology</li>
            <li>Ophthalmology</li>
            <li>Psychiatry</li>
            <li>Rheumatology</li>
            <li>Urology</li>
          </ul>
        ),
      },
    ],
  },
];

export enum EngagementScrollAnchor {
  GettingStarted = 'gettingstarted',
  Experts = 'experts',
  Details = 'details',
  LetUsHelp = 'letushelp',
}

const Engagement: React.FC<RouteComponentProps> = ({ history }) => {
  return (
    <DefaultPage wideContent={true} noPaddingBottom={true}>
      <section className={[styles.section, styles.section1].join(' ')}>
        <div className={styles.sectionContent}>
          <ScrollElement name={EngagementScrollAnchor.GettingStarted}>
            <h1 className={styles.bigHeader}>
              Be&nbsp;curious. Discover the&nbsp;unexpected.
            </h1>
            <div className={styles.row}>
              <div className={styles.rowCell1}>
                <h3 className={styles.smallHeader}>
                  <b>ACCESS</b>EXPRESS gives you the&nbsp;power to&nbsp;think
                  without restraint, gain fresh insights, and&nbsp;learn from
                  unanti&shy;ci&shy;pated per&shy;spec&shy;tives.
                </h3>
              </div>
              <div className={styles.rowCell2}>
                <p className={styles.normalText}>
                  <b>ACCESS</b>EXPRESS is&nbsp;a&nbsp;simple, self-service
                  market research tool that streamlines the&nbsp;complexities of
                  the&nbsp;survey process, so you can quickly probe unrivaled
                  panels of&nbsp;industry experts to&nbsp;get the&nbsp;credible,
                  actionable insights that can confirm your current strategy,
                  or&nbsp;guide you confidently forward in new directions.
                </p>
                <div className={styles.section1Buttons}>
                  <ActionButton
                    type="primaryAlt"
                    text="Learn more"
                    onClick={() => {
                      scroller.scrollTo(EngagementScrollAnchor.Details, {
                        duration: 400,
                        delay: 0,
                        offset: -20,
                        smooth: 'easeInOutQuart',
                      });
                    }}
                  />
                  <ActionButton
                    type="secondary"
                    text="Shop expert panels and surveys"
                    onClick={() => history.push('/choosePanel')}
                  />
                </div>
              </div>
            </div>
          </ScrollElement>
        </div>
      </section>
      <section className={[styles.section, styles.section2].join(' ')}>
        <div className={styles.sectionContent}>
          <ScrollElement name={EngagementScrollAnchor.Experts}>
            <div className={styles.row}>
              <h2 className={[styles.mediumHeader, styles.rowCell1].join(' ')}>
                Who Are Our Provider &amp;&nbsp;Payer Experts?
              </h2>
              <p className={[styles.normalText, styles.rowCell1].join(' ')}>
                <b>ACCESS</b>EXPRESS continues to develop and nurture robust
                groups of market access stakeholders with 100% of the leading
                health plans and pharmacy benefit managers (PBMs), the top 100
                hospital systems, and the top 200 oncology centers in the US.
              </p>
            </div>
          </ScrollElement>
          <PanelTiles tiles={tiles} />
        </div>
      </section>
      <section className={[styles.section, styles.section3].join(' ')}>
        <div className={styles.sectionContent}>
          <ScrollElement name={EngagementScrollAnchor.Details}>
            <h2 className={styles.mediumHeader}>
              How <b>ACCESS</b>EXPRESS makes getting life sciences market access
              answers quick&nbsp;&&nbsp;easy
            </h2>
          </ScrollElement>
          <div className={styles.row}>
            <div className={[styles.section3Main, styles.rowCell1].join(' ')}>
              <p className={styles.normalText}>
                <b>ACCESS</b>EXPRESS lets you survey hard-to-reach
                payer/provider experts to get answers to your questions as they
                are answered, within hours.
              </p>
              <p>
                Just pick your expert panel and build your survey with either
                one of our smart templates, or create your own. We can also help
                guide you to the right expert panels we recommend based on your
                answers to two simple questions.
              </p>
              <p className={styles.normalText}>
                Our survey builder is easy to use and mobile-friendly, and it
                gives you real-time insights.
              </p>
            </div>
            <div className={styles.rowCell1}>
              <ul className={styles.steps}>
                <li className={styles.step1}>
                  <h4 className={styles.stepTitle}>Step 1</h4>
                  <p className={styles.stepContent}>
                    Pick the expert panel that gives you the market access
                    answers you need.
                  </p>
                </li>
                <li className={styles.step2}>
                  <h4 className={styles.stepTitle}>Step 2</h4>
                  <p className={styles.stepContent}>
                    Create up to 10 survey questions by choosing from our
                    library of smart templates or create your own.
                  </p>
                </li>
                <li className={styles.step3}>
                  <h4 className={styles.stepTitle}>Step 3</h4>
                  <p className={styles.stepContent}>
                    Your insights will arrive in your dashboard in real time -
                    within hours - as panel experts submit.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className={[styles.section, styles.section4].join(' ')}>
        <div className={styles.sectionContent}>
          <ScrollElement name={EngagementScrollAnchor.LetUsHelp}>
            <h2 className={[styles.mediumHeader, styles.fullWidth].join(' ')}>
              Let <b>ACCESS</b>EXPRESS help you with selections
            </h2>
            <div className={styles.section4Content}>
              <h3 className={styles.smallHeader}>
                You have pressing questions about healthcare market access, but
                you may be unsure on how to find the right expert panel(s) to
                your questions.
              </h3>
              <div className={styles.row}>
                <div className={styles.rowCell1}>
                  <p>
                    Depending on what type of product you’re launching or
                    marketing, where you are in your product lifecycle, and what
                    your business questions are, we help connect you with the
                    right expert panels.
                  </p>
                  <p>
                    Click “Help me select a panel” and we’ll take you through
                    two questions to identify the expert panel(s) and survey(s)
                    that will best provide the answers you need.
                  </p>
                </div>
                <div
                  className={[styles.rowCell1, styles.section4Button].join(' ')}
                >
                  <ActionButton
                    type="primaryAlt"
                    onClick={() => history.push('/choosePanel')}
                    text="Help me select a panel"
                  />
                </div>
              </div>
            </div>
          </ScrollElement>
        </div>
      </section>
    </DefaultPage>
  );
};

export default withRouter(Engagement);
